function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import ListPolizaRenewal from "./ListPolizaRenewal";
import ModalPolizaRenewal from "./components/ModalPolizaRenewal";
import { ReactiveBase, ReactiveList, DataSearch, MultiDropdownList, DateRange, SelectedFilters } from "@appbaseio/reactivesearch"; // No idea why visual studio says that this is wrong

import moment from "moment";
import "moment/locale/es";
import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";
import "../../helperComponents/Elasticsearch/elasticsearch.scss";
import { componentIds } from "./utils";

var IndexPolizaRenewals = function IndexPolizaRenewals(props) {
  // remove cancelled and annulled polizas from the poliza renewals list
  var custom_post_filter_terms = {
    terms: {
      "poliza.aasm_state": ["draft", "waiting_activation", "active", "inactive"]
    }
  };

  var defaultQuery = function defaultQuery() {
    return {
      timeout: "10s",
      post_filter: {
        bool: {
          must: [custom_post_filter_terms]
        }
      }
    };
  };

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedPolizaRenewal = _React$useState2[0],
      setSelectedPolizaRenewal = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      openModal = _React$useState4[0],
      setOpenModal = _React$useState4[1];

  var _React$useState5 = React.useState("updated_at"),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      sortField = _React$useState6[0],
      setSortField = _React$useState6[1];

  var _React$useState7 = React.useState("desc"),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      sortOrder = _React$useState8[0],
      setSortOrder = _React$useState8[1];

  var scrollPositionRef = React.useRef(0);
  var aYearAgo = moment().subtract(2, "years").toDate();
  var today = moment().toDate(); // componentIds function moved to utils.ts

  var handleSort = function handleSort(field) {
    // Guardar la posición actual del scroll
    scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop || window.scrollY;

    if (sortField === field) {
      // Si es el mismo campo, alternar entre asc y desc
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // Si es un campo diferente, establecerlo y empezar con desc
      setSortField(field);
      setSortOrder("desc");
    }
  }; // Efecto para restaurar el scroll después de que se actualice el componente


  React.useEffect(function () {
    if (scrollPositionRef.current > 0) {
      // Usar múltiples intentos para asegurar que el scroll se restaure
      var restoreScroll = function restoreScroll() {
        window.scrollTo({
          top: scrollPositionRef.current,
          behavior: 'auto' // Sin animación para que sea instantáneo

        });
      }; // Intentar restaurar inmediatamente


      restoreScroll(); // Intentar de nuevo después de que React haya actualizado el DOM

      requestAnimationFrame(function () {
        restoreScroll(); // Un intento más después de un pequeño delay para asegurar

        setTimeout(function () {
          restoreScroll();
        }, 50);
      });
    }
  }, [sortField, sortOrder]);

  var renderList = function renderList() {
    return /*#__PURE__*/React.createElement(ReactiveList, {
      componentId: "PolizaRenewalsList" //highlight
      ,
      defaultQuery: defaultQuery,
      dataField: sortField,
      pagination: true,
      size: 50,
      loader: "Cargando resultados...",
      sortBy: sortOrder,
      showResultStats: true,
      react: {
        and: componentIds()
      },
      render: function render(_ref) {
        var data = _ref.data;
        return /*#__PURE__*/React.createElement(ReactiveList.ResultListWrapper, {
          style: {
            width: "100%",
            overflow: "visible"
          }
        }, data.id, /*#__PURE__*/React.createElement(ListPolizaRenewal, {
          polizaRenewals: data,
          onSelectedPolizaRenewal: onSelectedPolizaRenewal,
          sortField: sortField,
          sortOrder: sortOrder,
          onSort: handleSort
        }));
      }
    });
  };

  var renderOptions = function renderOptions() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DataSearch, {
      className: "col-md-4 elasticsearch-component",
      componentId: "poliza_id",
      dataField: ["poliza.id_keyword", "poliza.code", "poliza.contratante.full_name", "poliza.asegurado.full_name"],
      queryFormat: "and" // we need to search in all the fields
      ,
      fuzziness: 1,
      title: "N\xBA propuesta, N\xBA p\xF3liza, contratante o asegurado",
      placeholder: "Buscar",
      defaultQuery: defaultQuery,
      autosuggest: false // somehow it crashes with this
      ,
      react: {
        and: componentIds("poliza_id")
      },
      debounce: 300
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_ramo",
      dataField: "poliza.ramo.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Ramo",
      title: "Ramo",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("poliza_ramo")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_renewal_status_name",
      dataField: "status_name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Estado de la renovaci\xF3n",
      title: "Estado de la renovaci\xF3n",
      URLParams: false //loader="..."
      ,
      react: {
        and: componentIds("poliza_renewal_status_name")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_tipo_de_pago",
      dataField: "poliza.tipo_de_pago.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Forma de pago",
      title: "Forma de pago",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_tipo_de_pago")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_company_name",
      dataField: "poliza.company.name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Compa\xF1\xEDa",
      title: "Compa\xF1\xEDa",
      URLParams: false //loader="Cargando..."
      ,
      size: 1000,
      react: {
        and: componentIds("poliza_company_name")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "condition",
      dataField: "condition",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Condici\xF3n",
      title: "Condici\xF3n",
      URLParams: false,
      placeholder: "Selecciona una condici\xF3n",
      transformData: function transformData(data) {
        return data.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            label: item.key === 1 ? 'Iguales condiciones' : item.key === 2 ? 'Cambio condiciones' : item.key === 3 ? 'Sin condiciones' : item.key === 4 ? 'Extensión' : item.key === 5 ? 'Cliente rechaza renovación' : item.key === 6 ? 'Compañía rechaza renovación' : item.key
          });
        });
      },
      react: {
        and: componentIds("condition")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(MultiDropdownList, {
      componentId: "poliza_nombre_contratante",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      dataField: "poliza.contratante.full_name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Nombre contratante",
      title: "Contratante",
      URLParams: false,
      react: {
        and: componentIds("poliza_nombre_contratante")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      componentId: "poliza_nombre_asegurado",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      dataField: "poliza.asegurado.full_name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Nombre Asegurado",
      title: "Asegurado",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_nombre_asegurado")
      }
    }), /*#__PURE__*/React.createElement(DataSearch, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "prima_neta_range",
      dataField: ["poliza.commission.net_bonus"],
      title: "Prima Neta (mayor a UF)",
      placeholder: "Ej: 50 (para mayor a 50 UF)",
      showFilter: true,
      filterLabel: "Prima Neta",
      URLParams: false,
      queryFormat: "and",
      fuzziness: 0,
      autosuggest: false,
      customQuery: function customQuery(value) {
        return {
          query: {
            range: {
              "poliza.commission.net_bonus": {
                gte: parseFloat(value) || 0
              }
            }
          }
        };
      },
      react: {
        and: componentIds("prima_neta_range")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DataSearch, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "materia_asegurada",
      dataField: ["poliza.materia_asegurada_formatted"],
      title: "Materia Asegurada",
      placeholder: "Buscar por materia asegurada",
      showFilter: true,
      filterLabel: "Materia",
      URLParams: false,
      queryFormat: "and",
      fuzziness: 1,
      autosuggest: false,
      react: {
        and: componentIds("materia_asegurada")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DateRange, {
      componentId: "poliza_finish_date",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery //defaultValue={{
      //  start: aYearAgo,
      //  end: today,
      //}}
      ,
      dataField: "poliza.finish_date",
      title: "Fecha de fin vigencia",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      numberOfMonths: 2,
      queryFormat: "date",
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      componentId: "created_at",
      defaultQuery: defaultQuery,
      className: "col-md-4 elasticsearch-component" //defaultValue={{
      //  start: aYearAgo,
      //  end: today,
      //}}
      ,
      dataField: "created_at",
      title: "Fecha de creaci\xF3n",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      numberOfMonths: 2,
      queryFormat: "date",
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "updated_at",
      dataField: "updated_at",
      title: "Fecha de \xFAltima actualizaci\xF3n",
      numberOfMonths: 2,
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      queryFormat: "date",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(SelectedFilters, {
      showClearAll: true,
      clearAllLabel: "Limpiar filtros"
    })));
  };

  var onSelectedPolizaRenewal = function onSelectedPolizaRenewal(polizaRenewal) {
    setSelectedPolizaRenewal(polizaRenewal);
    setOpenModal(true);
  };

  return /*#__PURE__*/React.createElement("div", null, selectedPolizaRenewal && /*#__PURE__*/React.createElement(ModalPolizaRenewal, {
    polizaRenewal: selectedPolizaRenewal,
    open: openModal,
    onClose: function onClose() {
      setSelectedPolizaRenewal(null);
      setOpenModal(false);
    }
  }), /*#__PURE__*/React.createElement(ReactiveBase, {
    app: "poliza_renewals",
    url: "".concat(process.env.SEGUROS_API_URL) //analytics={true}
    ,
    headers: {}
  }, /*#__PURE__*/React.createElement("aside", null, renderOptions()), renderList()));
};

export default IndexPolizaRenewals;